import {
    Home,
    Users,
    BarChart3,
    Settings
} from "lucide-react";

const MENUS=[

    {
        icon:Home,
        label:"Dashboard",
        key:"dashboard"
    },

    {
        icon:Users,
        label:"Leads",
        key:"leads"
    },

    {
        icon:BarChart3,
        label:"Analytics",
        key:"analytics"
    },

    {
        icon:Settings,
        label:"Settings",
        key:"settings"
    }

];

export default function Sidebar(){

    return(

        <aside className="crm-sidebar">

          

            <nav>

                {

                    MENUS.map(item=>{

                        const Icon=item.icon;

                        return(

                            <button

                                key={item.key}

                                className="crm-sidebar-item"

                            >

                                <Icon size={18}/>

                                <span>

                                    {item.label}

                                </span>

                            </button>

                        );

                    })

                }

            </nav>
<style>{`.crm-sidebar{

    width:260px;

    background:#fff;

    border-right:1px solid #ececec;

    padding:20px;

}

.crm-logo{

    font-size:22px;

    font-weight:700;

    margin-bottom:30px;

}

.crm-sidebar-item{

    width:90%;

    display:flex;

    align-items:center;

    gap:12px;

    border:none;

    background:none;

    padding:12px;

    border-radius:10px;

    cursor:pointer;

}

.crm-sidebar-item:hover{

    background:#f4f6ff;

}`}</style>
        </aside>

    );

}